<template>
    <div class="energy-container">
        <div class="nodata" v-if="isEmpty()">暂无记录</div>
        <div v-else>
            <div class="top_banner">
                <div class="cur_text">当前活力值</div>
                <div class="cur_value">{{ totalScore }}</div>
                <div class="act_rule_link" @click="jumpToActRule">活动规则 ></div>
                <div class="tips" @click="handleTip">
                    <img src="~@/assets/images/energy_badge2x.png" alt="" />
                    <span v-if="scoreExpireTips">{{
                        `您有${scoreExpireTips.expiringScore}活力值将在${scoreExpireTips.expiringMonth}月1日过期，请尽快使用您的权益`
                    }}</span>
                    <span v-else>活力值领取后180天内有效，请尽快使用您的权益</span>
                </div>
            </div>
            <div class="panels">
                <MonthRecordPanel
                    :scoreSummary="monthSum"
                    class="panel"
                    v-for="monthSum in scoreSummary"
                    :key="monthSum.month"
                />
            </div>
        </div>
    </div>
</template>

<script>
import EnergyItem from '../../componets/records/energyItem';
import { List } from 'vant';
import recordsMixin from '@/common/js/mixin';
import MonthRecordPanel from '../../componets/records/monthRecordPanel';

export default {
    name: 'energy',
    components: { EnergyItem, VanList: List, MonthRecordPanel },
    mixins: [recordsMixin],
    data() {
        return {
            empty: false,
            totalScore: 0,
            scoreExpireTips: null,
            rulesUrl: '',
            scoreSummary: [],
            pageImp: false, // 页面是否曝光
            clickLock: false, // 防止重点
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],

                titleView: {
                    text: '活力值记录',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    // computed: {
    //     isEmpty() {
    //         return this.scoreSummary.length === 0;
    //     }
    // },
    created() {
        this.customeTitle(this.titleBar);
        this.onLoad();
    },
    methods: {
        isEmpty() {
            if (!this.scoreSummary || this.scoreSummary.length === 0) {
                return true;
            }
            return false;
        },
        pageImpPoint() {
            if (!this.pageImp) {
                let score = localStorage.getItem('KUserTotalScore') || 0;
                this.POINT('h5_element_imp', {
                    page: 'super-活力值记录页',
                    tgt_event_id: 'h5_ACT_scoreRecord',
                    tgt_name: 'h5-ACT-活力值记录页',
                    param: score,
                    param1: this.totalScore, // 当前活力值总数
                    param2: this.scoreExpireTips
                        ? `活力值领取后${this.scoreExpireTips.scoreExpireDays}天过期，您有${this.scoreExpireTips.expiringScore}活力值将在${this.scoreExpireTips.expiringMonth}月1日过期，请尽快使用您的权益`
                        : ''
                });
                this.pageImp = true;
            }
        },
        async onLoad() {
            let { Result, Content } = await this.$http.getScoreLogPageInfo();
            if (Result === 200) {
                const { totalScore, rulesUrl, scoreExpireTips, scoreSummaryList } = Content;
                this.totalScore = totalScore;
                this.rulesUrl = rulesUrl;
                this.scoreExpireTips = scoreExpireTips;
                this.scoreSummary = Object.freeze(scoreSummaryList);
                console.log('scoreSummary--11', this.scoreSummary);
                this.pageImpPoint();
            }
        },
        handleTip() {
            let score = localStorage.getItem('KUserTotalScore') || 0;
            this.POINT('h5_clk', {
                page: 'super-活力值记录页',
                tgt_event_id: 'h5_ACT_scoreRecord',
                tgt_name: 'h5-ACT-活力值记录页',
                param: score,
                param1: this.totalScore, // 当前活力值总数
                param2: this.scoreExpireTips
                    ? `活力值领取后${this.scoreExpireTips.scoreExpireDays}天过期，您有${this.scoreExpireTips.expiringScore}活力值将在${this.scoreExpireTips.expiringMonth}月1日过期，请尽快使用您的权益`
                    : ''
            });
        },
        jumpToActRule() {
            let score = localStorage.getItem('KUserTotalScore') || 0;
            this.POINT('h5_clk', {
                page: 'super-活力值记录页',
                tgt_event_id: 'h5_ACT_scoreRecord_hdgz',
                tgt_name: 'h5-ACT-活力值记录页-活动规则',
                param: score,
                param1: this.totalScore // 当前活力值总数
            });
            if (!this.clickLock) {
                this.clickLock = true;
                setTimeout(() => {
                    this.openLink(this.rulesUrl);
                    this.clickLock = false;
                }, 200);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.energy-container {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;
    .nodata {
        padding-top: 300px;
        font-size: 14px;
        // font-family: fzlt;
        color: #9a9eaa;
        background: #f7f7f7;
        text-align: center;
    }
    .top_banner {
        background-image: url('~@/assets/images/energy_record_top_banner2x.png');
        background-size: 100% 100%;
        width: 375px;
        height: 211px;
        position: relative;
        .cur_text {
            // width: 65px;
            height: 16px;
            font-size: 13px;
            // font-family: fzlt_bold;
            font-weight: bold;
            // font-weight: normal;
            color: #ffffff;
            line-height: 16px;
            position: absolute;
            left: 24px;
            // bottom: 148px;
            top: 42px;
        }
        .cur_value {
            width: 84px;
            height: 40px;
            font-size: 40px;
            font-family: uni_sans_regular;
            font-weight: 400;
            color: #ffffff;
            line-height: 48px;
            position: absolute;
            left: 24px;
            top: 67px;
        }
        .act_rule_link {
            width: 60px;
            height: 16px;
            font-size: 13px;
            // font-family: fzlt_bold;
            font-weight: bold;
            color: #ffffff;
            line-height: 16px;
            position: absolute;
            right: 28px;
            top: 83px;
            white-space: nowrap;
        }
        .tips {
            width: 347px;
            height: 30px;
            background: linear-gradient(315deg, #4891d8 0%, #67a5e2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 55px;
            border-radius: 30px;
            left: 50%;
            transform: translateX(-50%);
            img {
                width: 30px;
                height: 30px;
                position: absolute;
                left: 9px;
                top: 2px;
            }
            span {
                width: 271px;
                height: 30px;
                font-size: 11px;
                // font-family: fzlt;
                // font-weight: normal;
                color: #ffffff;
                white-space: nowrap;
                position: absolute;
                left: 45px;
                display: inline-block;
                line-height: 30px;
            }
        }
    }
    .panels {
        position: relative;
        top: -33px;
        .panel {
            margin: 0 auto;
            margin-bottom: 14px;
        }
    }
    .tip {
        width: 375px;
        height: 50px;
        background: #fff5e5;
        padding: 0 13px;
        display: flex;
        align-items: center;
        font-size: 13px;
        // font-family: fzlt;
        color: #f68b00;
        line-height: 16px;
    }
}
</style>
